import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import showSharedFolderPeoplePickerDialog from '../actions/showSharedFolderPeoplePickerDialog';

// mutates showPeoplePickerDialog flag which enables rendering of shared folder people-picker dialog
export default mutator(showSharedFolderPeoplePickerDialog, actionMessage => {
    getStore().showPeoplePickerDialog = actionMessage.showDialogMessageFlag;
});
